let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5WrjV")).then(() => parcelRequire('1tlkR'));